import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
const ChartShimmer = ({
  width,
  height,
  borderRadius,
  fullRow,
}: {
  width: string;
  height: string;
  borderRadius: string;
  fullRow: boolean;
  color?: string;
}) => {
  return (
    <Grid item xs={fullRow ? 12 : 6} data-testid="chart-shimmer">
      <Skeleton
        animation="wave"
        width={width}
        height={height}
        sx={{
          borderRadius,
        }}
        variant="rectangular"
      />
    </Grid>
  );
};
export default ChartShimmer;
